import { gql } from '@apollo/client'

import { SkillTokenParam } from '@karakuri-web/faq-component'
import { Maybe } from '@karakuri-web/faq-type'

export const GQL_SEARCH_FAQ = gql`
  query allFAQ(
    $botId: String!
    $inputValue: String!
    $searchType: String
    $count: Int = 20
    $tenantId: String
  ) {
    queryFAQ: queryFAQV2(
      query: {
        botId: $botId
        text: $inputValue
        count: $count
        searchType: $searchType
        tenantId: $tenantId
      }
    ) {
      id
      title
    }
  }
`

interface SkillToken {
  id: string
  token: string
}
export interface SkillTokenData {
  skillToken: SkillToken
}
export interface SkillTokenDataV2 {
  skillTokenV2: SkillToken
}

export interface SkillTokenVars {
  accountId: string
  skillId: string
  session?: string
  param: SkillTokenParam
}

export const GQL_FORM_TOKEN = gql`
  query formToken(
    $accountId: String!
    $skillId: String!
    $session: String
    $param: FAQSkillInputParam!
  ) {
    skillTokenV2(
      params: { accountId: $accountId, skillId: $skillId, session: $session, param: $param }
    ) {
      id
      token
    }
  }
`

export interface PulldownEvent {
  __krkr__: boolean
  type: 'send'
  query: { text: string }
}

export function isPulldownEvent(target: unknown): target is PulldownEvent {
  const event = target as PulldownEvent
  return event.__krkr__ && event.type === 'send'
}

export interface PulldownRequest {
  accountId: string
  tenantId?: Maybe<string>
  query: string
}

export interface PulldownResponse {
  pulldownQuery: {
    id?: string
  }
}

export const GQL_PULLDOWN = gql`
  query pulldown($accountId: String!, $tenantId: String, $query: String!) {
    pulldownQuery(params: { accountId: $accountId, tenantId: $tenantId, query: $query }) {
      id
    }
  }
`

export const GQL_SEARCHED_FAQ = gql`
  mutation searched($botId: String!, $tenantId: String, $text: String!) {
    searched: searched(input: { botId: $botId, tenantId: $tenantId, text: $text }) {
      result
    }
  }
`

export const GQL_TOP_FAQ = gql`
  query topPageViewFAQ($botId: ID!, $tenantId: String) {
    topPageViewFAQs(botId: $botId, tenantId: $tenantId) {
      id
      title
    }
  }
`

export const GQL_SEARCH = gql`
  query Search($input: FAQFilterSearchInputV2!) {
    search: searchV2(input: $input) {
      currentPage
      perPage
      total
      totalPages
      data {
        id
        title
        confidence
      }
    }
  }
`

export const GQL_COMPLETE = gql`
  query Complete($input: FAQCompleteInput!) {
    complete(input: $input)
  }
`
export const GQL_SUGGEST = gql`
  query Suggest($input: FAQSuggestInput!) {
    suggest(input: $input)
  }
`

export const GQL_CATEGORY_FAQ = gql`
  query faqByCategory($botId: ID!, $categories: [ID!]!, $tenantId: String) {
    filterByCategory(botId: $botId, categories: $categories, tenantId: $tenantId) {
      id
      title
    }
  }
`
